import actionTypes from '../constants/action-types';

const initiatePublishWebsite = (domain, isThirdPartyDomain) => ({
  type: actionTypes.INITIATE_PUBLISH_WEBSITE,
  payload: { domain, isThirdPartyDomain },
});

export default initiatePublishWebsite;
